import gql from 'graphql-tag';

export const ListDwellingsQuery = gql`
  query ListDwellingsQuery{
    dwellings {
        id
        name
        address_Street
        address_Street_Line2
        address_City
        address_Zip
        yearBuilt
        _Ebb_OwnerId
        _Ebb_OwnerId_Formatted
        _Ebb_ProgramCycleId
        _Ebb_ProgramCycleId_Formatted
        _Ebb_PolicyId
        homeownerOccupied
        stateCode
        stateCodeOptionSet
        statusCode
        statusCodeOptionSet
        ownerAssociation
       numberOfUnits
       squareFootage
       programCycle{
        typeCode
      }
        qualifications{
          id
          name
          response
          createdOn
        _Ebb_QuestionKey_Value
        }
      }
  }
`;
export const ListWithdrawnDwellingsQuery = gql`
  query ListWithdrawnDwellingsQuery{
    withdrawndwellings {
      id
      name
      _Ebb_OwnerId
      _Ebb_OwnerId_Formatted
      _Ebb_ProgramCycleId
      _Ebb_ProgramCycleId_Formatted
      _Ebb_PolicyId
      homeownerOccupied
      withdrawnDate
      withdrawReason
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      ownerAssociation
      numberOfUnits
      squareFootage
         __typename
      }
  }
`;
export const GetDwellingByIdQuery = gql`
  query GetDwellingQuery($id: String){
    dwelling(id: $id) {
      id
      name
      address_Street
      address_City
      address_Zip
      yearBuilt
      stateCode
      stateCodeOptionSet
      statusCode
      statusCodeOptionSet
      latitude
      longitude
      ownerAssociation
      numberOfUnits
      squareFootage
      _Ebb_ProgramCycleId
      _Ebb_PolicyId
    }
  }
`;

export const AnyDwellingsQuery = gql`
query AnyDwellings($email: String, $programCycleKey: String) {
  anydwellings(email: $email, programCycleKey: $programCycleKey)
}
`;
